import { ConfigReportComboApi } from "go-report-combo/User/services/types";
import { CatalogReportCombo } from "go-report-combo/User/template/Template/types";
import { REPORT_business_ranking_feature_kpi } from "./DefineReportList/business/business_ranking_feature_kpi";
import { REPORT_feature_enabled_team_kpi } from "./DefineReportList/business/feature_enabled_team_kpi";
import { REPORT_feature_potential_team_kpi } from "./DefineReportList/business/feature_potential_team_kpi";
import { REPORT_feature_tl_kpi } from "./DefineReportList/business/feature_tl_kpi";
import { REPORT_feature_used_team_details_kpi } from "./DefineReportList/business/feature_used_team_details_kpi";
import { REPORT_feature_used_team_kpi } from "./DefineReportList/business/feature_used_team_kpi";
import { REPORT_organization_with_not_potential_kpi } from "./DefineReportList/business/organization_with_not_potential_kpi";
import { REPORT_cs_feature_name_first_kpi } from "./DefineReportList/cs/cs_feature_name_first_kpi";
import { REPORT_cs_feature_name_kpi } from "./DefineReportList/cs/cs_feature_name_kpi";
import { REPORT_cs_feature_person_kpi } from "./DefineReportList/cs/cs_feature_person_kpi";
import { REPORT_cs_person_kpi } from "./DefineReportList/cs/cs_person_kpi";
import { REPORT_cs_product_kpi } from "./DefineReportList/cs/cs_product_kpi";
import { REPORT_cs_progress_kpi } from "./DefineReportList/cs/cs_progress_kpi";
import { REPORT_goorder_kpi } from "./DefineReportList/goorder/goorder_kpi";
import { REPORT_kam_person_kpi } from "./DefineReportList/kam/kam_person_kpi";
import { REPORT_kam_source_kpi } from "./DefineReportList/kam/kam_source_kpi";
import { REPORT_management_default } from "./DefineReportList/management/management_default";
import { REPORT_management_upselling } from "./DefineReportList/management/management_upselling";
import { REPORT_management_upselling_department } from "./DefineReportList/management/management_upselling_department";
import { onboarding_feature_new_full_kpi } from "./DefineReportList/onboarding/onboarding_feature_new_full_kpi";
import { REPORT_onboarding_person_kpi } from "./DefineReportList/onboarding/onboarding_person_kpi";
import { REPORT_onboarding_product_kpi } from "./DefineReportList/onboarding/onboarding_product_kpi";
import { REPORT_kpi_product } from "./DefineReportList/sales/kpi_product";
import { REPORT_kpi_product_q } from "./DefineReportList/sales/kpi_product_q";
import { REPORT_management_source } from "./DefineReportList/sales/management_source";
import { REPORT_sales_kpi } from "./DefineReportList/sales/sales_kpi";
import { REPORT_sales_person_kpi } from "./DefineReportList/sales/sales_person_kpi";
import { REPORT_sales_source } from "./DefineReportList/sales/sales_source";

const createCatalog = (config: ConfigReportComboApi) => {
	return {
		id: config.id,
		name: config.name,
		description: config.name,
		category: "BASIC",
		data: config,
	} as CatalogReportCombo;
};
const catalogTemplates = [
	createCatalog(REPORT_feature_tl_kpi),
	createCatalog(REPORT_feature_used_team_details_kpi),
	createCatalog(REPORT_organization_with_not_potential_kpi),
	createCatalog(REPORT_business_ranking_feature_kpi),
	createCatalog(REPORT_feature_potential_team_kpi),
	createCatalog(REPORT_feature_enabled_team_kpi),
	createCatalog(REPORT_feature_used_team_kpi),
	createCatalog(REPORT_cs_feature_name_first_kpi),
	createCatalog(REPORT_cs_feature_name_kpi),
	createCatalog(REPORT_cs_feature_person_kpi),
	createCatalog(REPORT_goorder_kpi),
	createCatalog(REPORT_kam_person_kpi),
	createCatalog(REPORT_kam_source_kpi),
	createCatalog(REPORT_onboarding_person_kpi),
	createCatalog(REPORT_onboarding_product_kpi),
	createCatalog(onboarding_feature_new_full_kpi),
	createCatalog(REPORT_cs_progress_kpi),
	createCatalog(REPORT_cs_person_kpi),
	createCatalog(REPORT_cs_product_kpi),
	createCatalog(REPORT_management_upselling_department),
	createCatalog(REPORT_management_upselling),
	createCatalog(REPORT_management_default),
	createCatalog(REPORT_kpi_product_q),
	createCatalog(REPORT_management_source),
	createCatalog(REPORT_kpi_product),
	createCatalog(REPORT_sales_kpi),
	createCatalog(REPORT_sales_person_kpi),
	createCatalog(REPORT_sales_source),
] as CatalogReportCombo[];

export const CATALOG_TEMPLATE_LIST = catalogTemplates;
